<template>
  <div id="overviewRevenue">
    <v-row v-if="showGraphs">
      <v-col cols="12" md="12">
        <base-material-card
            id="chartist-revenues"
            color="#009f4c"
            icon="fas fa-piggy-bank"
            class="px-4 py-3">
          <template v-slot:after-heading>
            <div class="display-1 font-weight-light mt-2">
              Revenue
              <span class="subtitle-1"></span>
            </div>
          </template>

          <chartist
              :data="overviewRevenuesLineChart.data"
              :options="overviewRevenuesLineChart.options"
              :responsive-options="overviewRevenuesLineChart.responsiveOptions"
              color="default"
              type="Line"
              style="max-height: 80vh;"
              class="mt-3 ml-4"
          />
        </base-material-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import RequestIcon from '../icons/RequestIcon'
import ImpressionsIcon from '../icons/ImpressionstIcon'
import FillRateIcon from '../icons/FillRateIcon'
import ViewabilityIcon from '../icons/ViewabilityIcon'
import ClickIcon from '../icons/ClickIcon'
import CTRIcon from '../icons/CTRIcon'
import CPMIcon from '../icons/CPMIcon'
import RPMIcon from '../icons/RPMIcon'
import RevenuesIcon from '../icons/RevenuesIcon'

const chartOptions = {
  options: {
    width: screen.width - 100 + 'px',
    height: screen.height - 400 + 'px',
    low: 0,
    // high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
    chartPadding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    },
    showPoint: false,
    fullWidth: true,
    showArea: true
  },
  responsiveOptions: [
    ['screen and (max-width: 640px)', {
      // seriesBarDistance: 5,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value[0]
        }
      }
    }]
  ]
}

export default {
  name: 'OverviewSingle',
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false
    }
  },
  components: {
    RevenuesIcon,
    RPMIcon,
    CPMIcon,
    CTRIcon,
    ClickIcon,
    ViewabilityIcon,
    FillRateIcon,
    ImpressionsIcon,
    RequestIcon
  },
  props: ['reports', 'showGraphs'],
  computed: {
    overviewRevenuesLineChart() {
      const data = {labels: [], series: [[]]}

      if (!this.reports) return Object.assign(chartOptions, {data: data})

      _.each(this.reports.daily, (val, key) => {
        data.labels.push(key)
        data.series[0].push(val.revenues)
      })

      return Object.assign(chartOptions, {data: data})
    },
    overviewRPMLineChart() {
      const data = {labels: [], series: [[], []]}

      if (!this.reports) return Object.assign(chartOptions, {data: data})

      _.each(this.reports.daily, (val, key) => {
        data.labels.push(key)
        data.series[0].push(val.rpm)
        data.series[1].push(val.page_rpm)
      })

      return Object.assign(chartOptions, {data: data})
    },
    overviewPagesLineChart() {
      const data = {labels: [], series: [[], []]}

      if (!this.reports) return Object.assign(chartOptions, {data: data})

      _.each(this.reports.daily, (val, key) => {
        if (val.pageviews) {
          data.labels.push(key)
          data.series[0].push(val.pageviews)
        }
      })

      return Object.assign(chartOptions, {data: data})
    }
  },
  filters: {
    integer(val) {
      return Number(val).toLocaleString(undefined, {maximumFractionDigits: 2})
    },
    decimals(val) {
      return Number(val).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    percent(val) {
      return val + '%'
    },
    eur(val) {
      return val + ' €'
    }
  }
}
</script>

<style lang="sass">
#chartist-revenues
  .ct-series-a .ct-line,
  .ct-series-a .ct-point
    stroke: #009f4c !important

  .ct-series-a .ct-area
    fill: #009f4c !important

#overviewRevenue .ct-square
  width: 98% !important
</style>
